import $ from 'jquery';

export default class Contact {
  constructor(section) {
    this.$el = $(section.el);

    $('.contact-form', this.$el).on('submit', () => this.spamCheck());
  }

  spamCheck(event) {
    if ($(event.target).find('.spam-check').val().length > 0) {
      event.preventDefault();
    }
  }
}
